export const fromFields = Object.freeze({
  SECTION_SALES_EXPERIENCE_IS_PUBLIC: 'sectionSalesExperienceIsPublic' as const,
  POSITION: 'position' as const,
  DEPARTMENTS: 'departments' as const,
  PRODUCT_TYPES: 'productTypes' as const,
  INDUSTRIES: 'industries' as const,
  COMPANY_STAGES: 'companyStages' as const,
  WAR_ROOM_SALES_ROLES: 'warRoomSalesRoles' as const,
  COMPANY_SERIES_STAGES: 'companySeriesStages' as const,
});

export const fromFieldTitles: Record<string, string> = Object.freeze({
  [fromFields.POSITION]: 'position',
  [fromFields.DEPARTMENTS]: 'departments',
  [fromFields.PRODUCT_TYPES]: 'specific products',
  [fromFields.INDUSTRIES]: 'products',
  [fromFields.COMPANY_STAGES]: 'size of companies',
  [fromFields.WAR_ROOM_SALES_ROLES]: 'roles',
  [fromFields.COMPANY_SERIES_STAGES]: 'company stages',
  [fromFields.COMPANY_SERIES_STAGES]: 'company stages',
});
